export * from './src/ecom-v1-wishlist-wishlists.meta.js';
